<template>
    <div>
        <v-row>
            <v-col 
                align-self="center"
                class="v-label theme--light mt-3 ml-6"
            >
                <BaseHeaderStats 
                    context="AzSocieties" 
                    typeStats="LIST"
                    :alvqa="alvqa + '-list'"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'

export default {
    name: "AzSocietiesTopSlot",
    components: {
        BaseHeaderStats
    },
    data() {
        return {
            alvqa: "az-societies"
        }
    }
}
</script>